import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment'
import './car.scss'

class CarComponent extends Component {

  render() {
    const orderDetail = this.props.data
    // const weekJson = { 1: '周一', 2: '周二', 3: '周三', 4: '周四', 5: '周五', 6: '周六', 7: '周日' };
    let times = [moment(orderDetail.bookingGaincarTime), moment(orderDetail.bookingBackcarTime)];
    let months = times.map(item => item.format('MM月DD日'));
    // let weeks = times.map(item => weekJson[item.format('E')]);
    let hours = times.map(item => item.format('HH:mm'));
    return <div>
      <div className="shadow-box card">
        <div className="header">
          <div className="img">
            <img alt='' src={orderDetail.pictureUrl} />
          </div>
          <div className="ml5">
            <div className="font14 c3 mt5 weight">{orderDetail.modelName}</div>
            <div className="font11 c9 mt5">{ orderDetail.gearboxType } { orderDetail.passengerCount }座 { orderDetail.outputVolume }L</div>
          </div>
        </div>
        <div className="line mb15"></div>
        <div className="main">
          <div className="main-text">
            <div>{ orderDetail.gaiStoreName }</div>
            <div>{ months[0]}{ hours[0]}</div>
          </div>
          <div className="main-center">
            <div>{ orderDetail.bookingRentalDays }天</div>
            <div className="line"></div>
          </div>
          <div className="main-text">
            <div>{ orderDetail.backStoreName }</div>
            <div>{ months[1]} { hours[1]}</div>
          </div>
        </div>
      </div>
    </div>
  }
}

const mapState = connect(state => {
  const { orderReducer } = state
  return { orderReducer }
})

export default mapState(CarComponent)